// ../Tools/ErrorDialog.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const ErrorDialog = ({ open, onClose, errorMessage }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle className="bg-red-100 text-red-800 font-bold">
        ❌ Error
      </DialogTitle>
      <DialogContent className="bg-white text-gray-800 py-4">
        {errorMessage || "An unexpected error occurred. Please try again."}
      </DialogContent>
      <DialogActions className="bg-red-50 px-6 py-4">
        <Button onClick={onClose} variant="contained" color="error">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
